export default "__VITE_ASSET__33953af9__$_?component__"